function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m22.38 5.035.001-.001a.402.402 0 0 0 0-.571L18.52.62a.412.412 0 0 0-.58-.001h-.001L14.72 3.82a.402.402 0 0 0 0 .572l3.861 3.845 3.8-3.202zm0 0-3.216 3.202m3.216-3.202-3.216 3.202m0 0a.414.414 0 0 1-.583 0h.583zM6.108 21.15l-5.093 1.335-.002.001A.407.407 0 0 1 .511 22l1.233-5.178a.404.404 0 0 1 .107-.193l10.94-10.886c.16-.16.421-.16.582 0l3.86 3.84a.405.405 0 0 1 0 .574l-.147.146v.002L6.294 21.043a.412.412 0 0 1-.186.107z",
  fill: "currentColor",
  stroke: "currentColor"
});

function SvgEditLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditLarge);
export default __webpack_public_path__ + "static/media/edit_large.fb108446.svg";
export { ForwardRef as ReactComponent };